import { ProgressSpinner } from 'primereact/progressspinner';
import { FC } from 'react';

interface PageLoaderProps {
  visible: boolean;
  text?: string;
}

export const PageLoader: FC<PageLoaderProps> = ({ visible, text = 'Loading...' }) => {
  return (
    <div
      className={`absolute top-0 left-0 w-full h-full z-50 bg-white/60 backdrop-blur-sm flex flex-col justify-center items-center ${!visible ? 'hidden' : ''}`}
    >
      <ProgressSpinner
        style={{ width: '60px', height: '60px' }}
        strokeWidth="4"
        fill="var(--surface-ground)"
        animationDuration=".8s"
      />
      <p className="mt-4 text-lg font-semibold text-gray-700">{text}</p>
    </div>
  );
};
